import { ChangeDetectionStrategy, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { LnInstagramSvgIconComponent } from '../svg-icons/ln-instagram-svg-icon/ln-instagram-svg-icon.component';
import { LnFacebookSvgIconComponent } from '../svg-icons/ln-facebook-svg-icon/ln-facebook-svg-icon.component';
import { LnWhatsappSvgIconComponent } from '../svg-icons/ln-whatsapp-svg-icon/ln-whatsapp-svg-icon.component';
import { LnLinkedinSvgIconComponent } from '../svg-icons/ln-linkedin-svg-icon/ln-linkedin-svg-icon.component';
import { SocialsNetworks } from '@enums/socials-networks';
import { ShareService } from '@core/services/share/share.service';
import { Router } from '@angular/router';
import { SharePayLoadInterface } from '@interfaces/share/share-playLoad-interface';
import { TranslocoPipe } from '@jsverse/transloco';
import { timer } from 'rxjs';
import { ClipBoardService } from '@core/services/clipBoard/clip-board.service';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-product-info-detail-share-bar',
  imports: [
    LnInstagramSvgIconComponent,
    LnFacebookSvgIconComponent,
    LnWhatsappSvgIconComponent,
    LnLinkedinSvgIconComponent,
    TranslocoPipe,
    NgClass,
  ],
  templateUrl: './ln-product-info-detail-share-bar.component.html',
  styleUrl: './ln-product-info-detail-share-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductInfoDetailShareBarComponent {
  @Input({ required: true }) productName!: string;
  protected showLinkCopied: WritableSignal<boolean> = signal(false);
  protected socialNetworkSelected: WritableSignal<SocialsNetworks | null> = signal(null);
  private shareService = inject(ShareService);
  private clipboard = inject(ClipBoardService);
  private router = inject(Router);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  updateSocialNetworks(socialNetworks: SocialsNetworks | null): void {
    this.socialNetworkSelected.set(socialNetworks);
  }

  protected readonly SocialsNetworks = SocialsNetworks;

  playLoad(): SharePayLoadInterface {
    const fullUrl = window.location.origin + this.router.url;

    return {
      title: this.productName,
      text: 'Échale un vistazo a este producto en Luna Nueva Home',
      url: fullUrl,
    };
  }

  shareWhatsapp() {
    this.shareService.open('whatsapp', this.playLoad());
  }
  shareFacebook() {
    this.shareService.open('facebook', this.playLoad());
  }
  shareLinkedIn() {
    this.clipboard.copy(this.playLoad().url);
    this.showLinkCopied.set(true);
    timer(1000).subscribe(() => {
      this.showLinkCopied.set(false);
    });
    // this.shareService.open('linkedin', this.playLoad());
  }
  async shareInstagram() {
    const ok = await this.shareService.nativeShare(this.playLoad());
    if (!ok) {
      await this.shareService.copyToClipboard(this.playLoad().url);
      alert('No se puede compartir directo a Instagram desde la web. Enlace copiado: ábrelo y pégalo en Instagram.');
    }
  }
}
